import React from 'react'
import maint from '../Maintenance.svg'
import '../css/maint.css'
const Maintenence = ({settinData}) => {
  return (
    <div
      className='leftContainer mb_space'
      style={{ minHeight: '100vh', height: '100%' }}
    >
      <div className=' '>
        <div
          className='bg_maint'
          style={{ backgroundImage: "url('../images/maint.svg')" }}
        ></div>
        <div className='bg_cont'>
          {settinData?.rk3g}
        </div>
      </div>
    </div>
  )
}

export default Maintenence
